module.exports = __webpack_public_path__ + "static/media/Moon.7c4e9041.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Moon.png
// module id = 58
// module chunks = 0